import React from 'react'
import { Box, Button } from '@material-ui/core'

import useDocumentGenerate from 'hooks/useDocumentGenerate'

import theme from 'theme'

const StepperActions = () => {
  const {
    disabledNextButton,
    handleAdvanceStep,
    handleBack,
    nextButtonText,
    wantsToAdvanceStep,
    wantsToReturnStep,
    showBackButton,
  } = useDocumentGenerate()

  return (
    <Box
      display="flex"
      justifyContent="flex-end"
      gridGap={theme.spacing(2)}
      mt={2}
    >
      {showBackButton && (
        <Button
          onClick={handleBack}
          variant="outlined"
          disabled={wantsToReturnStep}
        >
          Voltar
        </Button>
      )}
      <Button
        onClick={handleAdvanceStep}
        variant="contained"
        color="primary"
        disabled={disabledNextButton || wantsToAdvanceStep}
      >
        {nextButtonText}
      </Button>
    </Box>
  )
}

export default StepperActions
